export const createPaymentWidgetScript = (url?: string) => {
    if (!url) return;
    const script = document.createElement('script');
    script.src = url;

    script.id = 'widget_vpn';
    script.async = true;
    document.body.appendChild(script);
};
